import { t } from "../i18n"
import { Controller } from "@hotwired/stimulus"

// Generic form UX: show spinner, disable submit, and animate closing any parent modal on success
export default class extends Controller {
  static targets = ["spinner"]

  connect() {
    this.onSubmitStart = this.onSubmitStart.bind(this)
    this.onSubmitEnd = this.onSubmitEnd.bind(this)
    this.element.addEventListener('turbo:submit-start', this.onSubmitStart)
    this.element.addEventListener('turbo:submit-end', this.onSubmitEnd)
  }

  disconnect() {
    this.element.removeEventListener('turbo:submit-start', this.onSubmitStart)
    this.element.removeEventListener('turbo:submit-end', this.onSubmitEnd)
  }

  onSubmitStart(event) {
    // Disable submit buttons/inputs
    const submits = this.submitButtons()
    submits.forEach(btn => {
      btn.dataset.originalValue = btn.value || btn.innerHTML
      btn.disabled = true
      btn.classList.add('is-loading')
      // Turbo will handle text via data-turbo-submits-with if present
    })

    // Show inline spinner if provided
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.remove('hidden')
    }
  }

  onSubmitEnd(event) {
    const { detail: { success } } = event

    // Re-enable submit buttons
    const submits = this.submitButtons()
    submits.forEach(btn => {
      btn.disabled = false
      btn.classList.remove('is-loading')
      // Restore label if we changed it (we didn't change programmatically)
      if (btn.tagName === 'BUTTON' && btn.dataset.originalValue) {
        btn.innerHTML = btn.dataset.originalValue
      } else if (btn.tagName === 'INPUT' && btn.dataset.originalValue) {
        btn.value = btn.dataset.originalValue
      }
    })

    // Hide inline spinner
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.add('hidden')
    }

    // Close parent modal on success with animation
    if (success) this.closeNearestModal()
  }

  submitButtons() {
    return Array.from(this.element.querySelectorAll('button[type="submit"], input[type="submit"]'))
  }

  closeNearestModal() {
    const overlay = this.element.closest('.modal-overlay')
    if (!overlay) return
    const card = overlay.querySelector('.modal-card')
    // add classes for CSS transition
    overlay.classList.add('is-closing')
    if (card) card.classList.add('is-hiding')
    // after transition, hide overlay
    const done = () => {
      overlay.style.display = 'none'
      overlay.classList.remove('is-open', 'is-closing')
      if (card) card.classList.remove('is-visible', 'is-hiding')
      overlay.removeEventListener('transitionend', done)
    }
    overlay.addEventListener('transitionend', done)
  }
}

